// Toegangsbeleid: zodra één wachtwoord overeenkomt, wordt ingelogd.
export const VALID_PASSWORDS: string[] = [
  'vggo2026',
  'vgov2026'
];



// WEBPACK FOOTER //
// ./src/config/passwords.ts